// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ga-0";
export var headerCellHover = "_ga-1";
export var readCellContainer = "_ga-2";
export var searchHighlight = "_ga-4";
export var unreadIndicator = "_ga-3";